/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliAttendanceStatus } from '../../models/amoxcalli-attendance-status';
import { AmoxcalliRegisterAttendanceByQrDto } from '../../models/amoxcalli-register-attendance-by-qr-dto';

export interface ApiAttendanceScanPost$Json$Params {
      body?: AmoxcalliRegisterAttendanceByQrDto
}

export function apiAttendanceScanPost$Json(http: HttpClient, rootUrl: string, params?: ApiAttendanceScanPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliAttendanceStatus>> {
  const rb = new RequestBuilder(rootUrl, apiAttendanceScanPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliAttendanceStatus>;
    })
  );
}

apiAttendanceScanPost$Json.PATH = '/api/attendance/scan';
